import BackButtonLayout from "core/layouts/backButtonLayout";
/* eslint-disable react/prop-types */
import React, { useContext, useState, useEffect } from "react";
import { withRouter, useHistory, RouteComponentProps } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { useTranslation } from "react-i18next";
import Divider from "@material-ui/core/Divider";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Context from "core/context/context";
import { useStyles } from "./styles";
import Container from "core/components/container";
import { DottedTabs } from "core/components/tabs";
import { TabProps, TabsProps } from "core/types";
import { OrderApi, OrderApiProps } from "api";

type Inputs = {
  orderid: string;
  email: string;
};
interface Props {
  step?: number;
}

const CheackOrders = (
  props: React.PropsWithChildren<Props & RouteComponentProps>
) => {
  const { t, i18n } = useTranslation();
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const classes = useStyles();
  const theme = useTheme();
  const tabs: TabsProps = {
    data: [
      {
        name: "Orders",
        id: 0,
        selected: true,
        click: (item: TabProps) => onTabClick(item),
      },
      {
        name: "Completed",
        id: 1,
        selected: false,
        click: (item: TabProps) => onTabClick(item),
      },
    ],
  };
  const [tabsItems, setTabsItems] = useState(tabs);
  const onTabClick = (item: TabProps) => {
    const items: TabsProps = newSelectionStatus(item);
    setTabsItems({ ...items });
  };

  const newSelectionStatus = (item: TabProps): TabsProps => {
    return {
      data: tabsItems.data.map((el) =>
        el.id === item.id
          ? { ...el, selected: true }
          : { ...el, selected: false }
      ),
    };
  };
  useEffect(() => {
    const params: OrderApiProps = { lang: win["lang"], customer: "" };
    OrderApi.getAllOrders(params)
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        console.log("done");
      });
  }, []);
  return (
    <>
      <Grid
        container
        style={{
          top: 0,
          background: "#008CFF",
          height: theme.spacing(30),
          width: "100vw",
        }}
      >
        <Container mt={theme.spacing(1.5)}>
          <DottedTabs data={tabsItems.data}></DottedTabs>
        </Container>
      </Grid>
      <BackButtonLayout>
        <Grid container direction="column">
          <Grid item sm={6} className={classes.bigTitle}>
            <Typography component={"span"} variant={"body2"}>
              <Box
                fontWeight={700}
                style={{
                  direction: langDir,
                }}
                width={"80%"}
                fontSize={theme.spacing(6)}
                mb={theme.spacing(0.6)}
                mt={theme.spacing(0.1)}
                letterSpacing={1}
              >
                {t("CheckYourLatestOrderStatus")}
              </Box>
            </Typography>
          </Grid>
          <Grid item sm={4} xs={12} style={{ marginTop: theme.spacing(4) }}>
            <List>
              {["Order ES-9191234", "Order ES-9190002", "Order ES-9190002"].map(
                (value, i) => (
                  <Typography key={i} component={"span"} variant={"body2"}>
                    <ListItem
                      alignItems="flex-start"
                      className={classes.listItem}
                      button
                    >
                      <ListItemText
                        primary={
                          <Box
                            fontSize={theme.spacing(1.8)}
                            fontWeight={"bold"}
                          >
                            {value}
                          </Box>
                        }
                        secondary={
                          <Box
                            fontSize={theme.spacing(1.8)}
                            fontWeight={"normal"}
                            color={"black"}
                            component={"span"}
                          >
                            {"18/08/2020"}
                          </Box>
                        }
                      />
                      <ListItemIcon>
                        {!isRTL ? (
                          <ArrowForwardIosIcon
                            color={"secondary"}
                            style={{ fontStyle: "bold" }}
                            fontSize={"small"}
                          />
                        ) : (
                          <ArrowBackIos color={"secondary"} />
                        )}
                      </ListItemIcon>
                    </ListItem>
                    <Divider variant="fullWidth" component="li" />
                  </Typography>
                )
              )}
            </List>
          </Grid>
        </Grid>
      </BackButtonLayout>
    </>
  );
};
export default withRouter(CheackOrders);
